export enum ProductModifierType {
    MULTIPLE_CHOICE = "MULTIPLE_CHOICE",
    MULTIPLE_CHOICE_WITH_QTY = "MULTIPLE_CHOICE_WITH_QTY"
}